import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'class-names';
import { connect } from 'react-redux';
import { formatMoney } from '../../functions';
import {
  closeCart,
  populateItems,
  updateItem,
  setGiftWrap,
  unsetGiftWrap,
  updateCart,
} from '../../redux/cart/actions';

import CartRhsItem from './CartRhsItem';
import IconChevronRight from '../icons/IconChevronRight';
import IconClose from '../icons/IconClose';

class CartRhsContent extends Component {
  constructor(props) {
    super(props);

    const {
      populateItems,
      pageLoadItems,
    } = props;

    populateItems(pageLoadItems);
    this.updatePackagingProductsInCart();
  }

  // Hooks ------------
  componentDidMount() {
    this.updateActiveState();
  }

  componentDidUpdate(prevProps) {
    const { isOpen, items } = this.props;
    if (!prevProps.isOpen && isOpen) {
      document.body.style.overflow = 'hidden';
    } else if (prevProps.isOpen && !isOpen) {
      document.body.style.overflow = '';
    }
    this.updateActiveState();
    if (items != prevProps.items) {
      this.updateGiftNoteAttr();
    }
  }

  // Getters / computed ------------
  isGiftWrapEnabled() {
    const {
      giftWrapEnabled,
      packagingProduct1,
      packagingProduct2,
    } = this.props;

    return giftWrapEnabled && (packagingProduct1 || packagingProduct2);
  }

  packagingProducts() {
    const {
      packagingProduct1,
      packagingProduct2,
    } = this.props;

    const value = [];
    packagingProduct1 && value.push(packagingProduct1);
    packagingProduct2 && value.push(packagingProduct2);
    return value;
  }

  packagingProductIds() {
    return this.packagingProducts().map((item) => String(item.id));
  }

  packagingProductsInCart() {
    const { items: cartItems } = this.props;
    const packagingProductIds = this.packagingProductIds();
    const value = cartItems.filter(
      (cartItem) => packagingProductIds.includes(String(cartItem.productId)),
    );

    return value;
  }

  giftNoteItem() {
    const cartItems = (this && this.props) ? this.props.items : [];
    return cartItems.find(({ type }) => type === 'giftnote_giftcard');
  }

  isGiftInCart() {
    return this.isGiftWrapEnabled()
      ? this.packagingProductsInCart().length > 0
      : false;
  }

  computed() {
    return {
      isGiftWrapEnabled: this.isGiftWrapEnabled(),
      packagingProducts: this.packagingProducts(),
      packagingProductIds: this.packagingProductIds(),
      packagingProductsInCart: this.packagingProductsInCart(),
      isGiftInCart: this.isGiftInCart(),
    };
  }

  // Methods ------------
  updateGiftNoteAttr() {
    const giftNoteItem = this.giftNoteItem();
    const { updateCart } = this.props;
    let giftnoteProps = {};

    if (giftNoteItem) {
      // add giftnote cart attributes
      giftnoteProps = giftNoteItem.properties.reduce(
        (res, prop) => {
          if (prop[0] && prop[0].charAt(0) != '_') return res;
          if (prop[0] && (
            prop[0].includes('__giftnote') || prop[0].includes('__giftcard')
          )) {
            const newKey = prop[0]
              .replace('__giftcard', '__giftnote')
              .replace('__giftnote', 'giftnote');
            res[newKey] = prop[1];
          }
          return res;
        }, {},
      );
      giftnoteProps.giftnote_method = 'instant';
    } else {
      // remove giftnote cart attributes
      giftnoteProps = {
        giftnote_medium: '',
        giftnote_method: '',
        giftnote_email: '',
        giftnote_to: '',
        giftnote_message: '',
        giftnote_from: '',
      };
    }

    updateCart({ attributes: giftnoteProps });
  }

  updateActiveState() {
    const { isGiftInCart } = this.computed();
    const { setGiftWrap, unsetGiftWrap } = this.props;
    if (isGiftInCart) {
      setGiftWrap();
    } else {
      unsetGiftWrap();
    }
  }

  updatePackagingProductsInCart() {
    const {
      items: cartItems,
      updateItem,
    } = this.props;
    const {
      isGiftInCart,
      packagingProductsInCart,
    } = this.computed();

    if (isGiftInCart) {
      if (cartItems.length === 1) {
        // Clear cart if only packaging product exists
        packagingProductsInCart.forEach((cartItem, index) => {
          updateItem(cartItem.key, 0);
        });
      } else if (cartItems.length > 1) {
        // Make sure only 1 packaging product is in cart
        packagingProductsInCart.forEach((cartItem, index) => {
          if (index === 0 && cartItem.quantity > 1) {
            updateItem(cartItem.key, 1);
          } else if (index > 0) {
            updateItem(cartItem.key, 0);
          }
        });
      }
    }
  }

  // Render ------------
  render() {
    let subtotal = 0;
    const {
      items, isOpen, closeCart, cartLink,
    } = this.props;
    items.forEach((item) => {
      subtotal += (item.quantity * item.itemPriceCents);
    });

    this.updatePackagingProductsInCart();

    return (
      <div role="button" className={classNames('cart-rhs', { 'cart-rhs--open': isOpen })}>
        {/* eslint-disable-next-line max-len */}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
        <div aria-label="Close" className="cart-rhs__bg" onClick={closeCart} />
        <div className="cart-rhs__drawer">
          <button type="button" className="cart-rhs__close-button button-text-only" onClick={closeCart}>
            <IconClose />
            <span className="sr-only">Close</span>
          </button>
          <h2>My Order</h2>
          <ul className="cart-rhs__list mb-3">
            {items && items.map((item) => (
              <CartRhsItem item={item} key={item.key} />
            ))}
          </ul>
          <p className="text-right mb-3">
            Subtotal:&nbsp;
            <span>{Shopify.currency.active + " " + formatMoney(subtotal)}</span>
          </p>
          <a href={cartLink} className="button">
            Go to Cart
          </a>
          <button className="button cart-rhs__continue-shopping" onClick={closeCart}>
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }
}

CartRhsContent.propTypes = {
  // text: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  isLoading: state.cart.isLoading,
  isOpen: state.cart.isOpen,
  items: state.cart.items,
});

const mapDispatchToProps = {
  closeCart,
  populateItems,
  updateItem,
  setGiftWrap,
  unsetGiftWrap,
  updateCart,
};

CartRhsContent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isOpen: PropTypes.bool,
  populateItems: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  setGiftWrap: PropTypes.func.isRequired,
  unsetGiftWrap: PropTypes.func.isRequired,
  updateCart: PropTypes.func.isRequired,

  pageLoadItems: PropTypes.arrayOf(PropTypes.object),
  attributes: PropTypes.objectOf(PropTypes.any),
  closeCart: PropTypes.func.isRequired,
  cartLink: PropTypes.string.isRequired,

  giftWrapEnabled: PropTypes.bool,
  packagingProduct1: PropTypes.objectOf(PropTypes.any),
  packagingProduct2: PropTypes.objectOf(PropTypes.any),
  // packagingVariants1: PropTypes.arrayOf(PropTypes.any),
  // packagingVariants2: PropTypes.arrayOf(PropTypes.any),
};

CartRhsContent.defaultProps = {
  items: [],
  pageLoadItems: [],
  isOpen: false,
  attributes: null,

  giftWrapEnabled: false,
  packagingProduct1: null,
  packagingProduct2: null,
  // packagingVariants1: [],
  // packagingVariants2: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(CartRhsContent);
